module.exports = __webpack_public_path__ + "static/img/bg.9307a88.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg.jpg
// module id = ctKR
// module chunks = 1